/**
 * Yeti Life Blog — Client-side topic category filtering
 * Tag filtering uses native Shopify /tagged/ URLs (server-side)
 * Topic categories filter client-side by matching article tags
 */
(function () {
  'use strict';

  const topicButtons = document.querySelectorAll('.yt-filter-topic');
  const articles = document.querySelectorAll('.blog-articles .border-item');
  const grid = document.querySelector('.blog-articles');
  const countEl = document.querySelector('.yt-articles-meta__count');
  var totalCount = articles.length;

  if (!topicButtons.length || !articles.length) return;

  function updateCount(visible) {
    if (!countEl) return;
    if (visible === totalCount) {
      countEl.textContent = totalCount + ' article' + (totalCount === 1 ? '' : 's');
    } else {
      countEl.textContent = visible + ' of ' + totalCount + ' article' + (totalCount === 1 ? '' : 's');
    }
  }

  topicButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Update active state
      topicButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var filterType = btn.getAttribute('data-filter');

      if (filterType === 'all') {
        // Show all
        articles.forEach(function (item) {
          item.classList.remove('yt-hidden');
        });
        removeNoResults();
        updateCount(totalCount);
        return;
      }

      // Category filter: match any of the category tags
      var categoryTags = btn.getAttribute('data-tags');
      if (!categoryTags) return;

      var tags = categoryTags.split(',').map(function (t) { return t.trim().toLowerCase(); });
      var visibleCount = 0;

      articles.forEach(function (item) {
        var itemTags = (item.getAttribute('data-tags') || '').toLowerCase();
        var match = tags.some(function (tag) {
          return itemTags.indexOf(tag) !== -1;
        });

        if (match) {
          item.classList.remove('yt-hidden');
          visibleCount++;
        } else {
          item.classList.add('yt-hidden');
        }
      });

      updateCount(visibleCount);

      // Show no-results message if needed
      if (visibleCount === 0) {
        showNoResults();
      } else {
        removeNoResults();
      }
    });
  });

  function showNoResults() {
    removeNoResults();
    if (!grid) return;
    var msg = document.createElement('li');
    msg.className = 'yt-no-results';
    msg.innerHTML = '<div class="yt-no-results__icon">&#x1f50d;</div>' +
      '<p class="yt-no-results__text">No articles found in this category</p>' +
      '<a href="' + window.location.pathname + '" class="yt-no-results__link">View all articles</a>';
    grid.appendChild(msg);
  }

  function removeNoResults() {
    var existing = document.querySelector('.yt-no-results');
    if (existing) existing.remove();
  }
})();